import { BarChart3 } from 'lucide-preact'
import { memo } from 'preact/compat'
import type { AnalyticsMetricDto } from '@/types/analytics'
import { AnalyticsStatTile } from './AnalyticsStatTile'

interface Props {
  metric: AnalyticsMetricDto | null
  loading: boolean
  error: string | null
}

export const ConversionsStatTile = memo(({ metric, loading, error }: Props) => (
  <AnalyticsStatTile
    title={<><span className="block">Conversions</span></>}
    icon={<BarChart3 className="w-5 h-5 text-primary-600 dark:text-primary-400" />}
    metric={metric}
    loading={loading}
    error={error}
  />
))
